export default {
  archTransferDetail: {
    component: () =>
      import(
        /* webpackChunkName: "transfer_detail" */ "../archTransfer/detailView/ArchTransferDetail"
      ),
  },
};
